import { ChangeDetectorRef, Directive, ElementRef, Input, NgZone, OnChanges, Optional, Renderer2, SimpleChanges } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzIconDirective, NzIconPatchService, NzIconService } from "ng-zorro-antd/icon";
import { UiThemeType } from "./icon.models";

@Directive({
  selector: "[ui-icon]",
  exportAs: "uiIcon",
  host: {
    "[class.anticon]": "true",
  },
  standalone: true,
})
export class UiIconDirective extends NzIconDirective implements OnChanges {
  @Input("uiRotate")
  public nzRotate = 0;

  @Input("uiSpin")
  @InputBoolean()
  public set nzSpin(value: boolean) {
    super.nzSpin = value;
  }

  @Input("uiType")
  public set nzType(value: string) {
    super.nzType = value;
  }

  @Input("uiTheme")
  public set nzTheme(value: UiThemeType) {
    super.nzTheme = value;
  }

  @Input("uiTwotoneColor")
  public set nzTwotoneColor(value: string) {
    super.nzTwotoneColor = value;
  }

  @Input("uiIconfont")
  public set nzIconfont(value: string) {
    super.nzIconfont = value;
  }

  constructor(
    ngZone: NgZone,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef,
    iconService: NzIconService,
    renderer: Renderer2,
    @Optional() iconPatch: NzIconPatchService
  ) {
    super(ngZone, changeDetectorRef, elementRef, iconService, renderer, iconPatch);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if ("nzType" in changes) {
      const el: HTMLElement = this._elementRef.nativeElement;
      if (!el.hasAttribute("data-test-id")) {
        const type: string = changes["nzType"].currentValue;
        if (type) {
          this.renderer.setAttribute(el, "data-test-id", `icon-${type}`);
        } else {
          this.renderer.removeAttribute(el, "data-test-id");
        }
      }
    }
  }
}
